import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { MemberConnectionStatus } from '../constants/Connect'
import { useGlobalCopyStore } from '../../common'

interface ConnectStatusProps {
  status?: MemberConnectionStatus
}

const ConnectStatus: React.FC<ConnectStatusProps> = ({
  status = MemberConnectionStatus.Loading,
}) => {
  const { connect: connectCopy } = useGlobalCopyStore()

  return (
    <Box
      sx={{
        height: 'calc(100% - 62px)',
        position: 'absolute',
        width: '100%',
      }}
    >
      <Stack alignItems="center" direction="column" justifyContent="center" sx={{ height: '100%' }}>
        {status === MemberConnectionStatus.Loading && (
          <CircularProgress color="primary" size={48} />
        )}
        <Text
          sx={{
            color: 'grey.600',
            marginTop: '16px',
          }}
        >
          {status === MemberConnectionStatus.Error ? connectCopy.oops : connectCopy.loading}
        </Text>
      </Stack>
    </Box>
  )
}

export default observer(ConnectStatus)
